<template>
  <v-list dense expand nav>
    <template v-for="(item, key) in items">
      <v-subheader v-if="item.heading" :key="key">
        {{ item.heading }}
      </v-subheader>
      <MultiItemSidebar
        v-if="item.children && item.children.length > 0"
        :key="key"
        :children="item.children"
        :item="item"
        :mini="mini"
      />
      <SingleItemSidebar v-else :key="key" :item="item" :mini="mini" />
    </template>
  </v-list>
</template>

<script>
import SingleItemSidebar from './sidebar/single-item-sidebar.vue'
import MultiItemSidebar from './sidebar/multi-item-sidebar.vue'
export default {
  components: { SingleItemSidebar, MultiItemSidebar },
  props: { mini: Boolean, items: { type: Array, default: () => [] } },
  data: () => ({}),
  computed: {},
  watch: {},
  methods: {},
}
</script>
